import * as Yup from "yup";

export const AncillaryValidation = Yup.object({
    documentType: Yup.string().required("Document type is required!"),
    ancillaryStatusId: Yup.string().required("Ancillary status is required!"),
    // documentUrl: Yup.string().required("Ancillary document is required!")
})
